document.addEventListener("DOMContentLoaded", function(){
  slider_arrow_left = '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="39.5" y="39.5" width="39" height="39" transform="rotate(180 39.5 39.5)" fill="white" stroke="black"/><path d="M18.78 10H16.58L9 20.06L16.58 30H18.78L12 21H31V19H12L18.78 10Z" fill="black"/></svg>';
  slider_arrow_right = '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="39.5" y="39.5" width="39" height="39" transform="rotate(180 39.5 39.5)" fill="white" stroke="black"/><path d="M21.22 30H23.42L31 19.94L23.42 10H21.22L28 19H9V21H28L21.22 30Z" fill="black"/></svg>';

  // if ($('.custom-promo-section-random-banner').length){
  //   $('.custom-promo-section-random-banner').each(function(){
  //     images_size = $(this).data('images-size');
  //     active_banner = Math.floor(Math.random() * images_size) + 1;
  //     $(this).find('.promo-section-image-'+active_banner).addClass('visible');
  //     $(this).addClass('visible');
  //   });
  // }

  $(document).on("click", ".custom-return-link", function(e){
    if (window.history.length > 1){
      e.preventDefault();
      window.history.back();
    }
  });

  $('.ul-wrapper .link-title').on('click', function(e){
    e.preventDefault();
    if(!$(this).hasClass('no-hover')){
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
      } else {
        $('.link-title.active').each(function(e){
          $(this).removeClass('active');
        });
        $(this).toggleClass('active').siblings().removeClass('active')
      }
    }
  });

  $(document).on("click", ".custom-collection-page-navigation", function(e){
    e.preventDefault();
    goTo = $(this).data("go-to");
    newPosition = $("#" + goTo).offset().top;
    currentPosition = document.documentElement.scrollTop;
    if ($(window).width() > 767){
      speedOptimization = 7;
    } else {
      speedOptimization = 4;
    }

    if (currentPosition > newPosition){
      newPosition = newPosition - $("#shopify-section-header").outerHeight();
      speed = (currentPosition - newPosition)/speedOptimization;
    } else {
      newPosition = newPosition - $("#shopify-section-header").outerHeight();
      speed = (newPosition - currentPosition)/speedOptimization;
    }
    $('html, body').animate({
      scrollTop: newPosition
    }, speed, function(){

      // Add hash (#) to URL when done scrolling (default click behavior)
      window.location.hash = goTo;
    });
  });

  if($('.go-to-store-button').length){
    $('.go-to-store-button').click(function(){
      const searchValue=$('.localisation-data').val();
      localStorage.setItem('searchValue', searchValue);
      window.location.href = '/pages/store-locator';
    });
  }

  if ($('.wrapper-for-run').length){
    $('.wrapper-for-run').on('click',function(){
       $('.newsletter-section').slideToggle(400);
    });
  }

  if ($('.panel').length){
    $(window).scroll(function() {

    // selectors
    var $window = $(window),
        $body = $('body'),
        $panel = $('.panel');
    // Change 33% earlier than scroll position so colour is there when you arrive.
    var scroll = $window.scrollTop() + ($window.height() / 3);

    $panel.each(function () {
        var $this = $(this);
        // if position is within range of this panel.
        // So position of (position of top of div <= scroll position) && (position of bottom of div > scroll position).
        // Remember we set the scroll to 33% earlier in scroll var.
        if ($this.position().top <= scroll && $this.position().top + $this.height() > scroll) {

        // Remove all classes on body with color-
        $body.removeClass(function (index, css) {
            return (css.match (/(^|\s)color-\S+/g) || []).join(' ');
        });

        // Add class of currently active div

        $body.attr('data-color','color-' + $(this).data('color'));
        }
    });

    }).scroll();
  }

  if ($('.gradient-slider').length){
    $('.gradient-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      nextArrow: `<span class = 'arrow-right'>${slider_arrow_right}</span>`,
      prevArrow: `<span class = 'arrow-left'>${slider_arrow_left}</span>`,
      dots: false,
      responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true
                  }
                },
                {
                  breakpoint: 700,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                }
              ]
    });
  }

  if($('.featured-product-slider').length){
    $('.featured-product-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      nextArrow: `<span class = 'arrow-right'>${slider_arrow_right}</span>`,
      prevArrow: `<span class = 'arrow-left'>${slider_arrow_left}</span>`,
      dots: false,
      responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true
                  }
                },
                {
                  breakpoint: 700,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                }
              ]
    });
  }
});

$(document).ready(function(){
  
  // localization form  
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);
  
  // -----  product dynamic shipping info function -----  
  // Geo location api
  GeolizrAPI.addEventListener('geolizr.geoData', function(geoData) {
    var countrycode = geoData.countryCode;
    if(countrycode == 'BE'){
      $('.js-begium').show();
    } else {
      $('.js-overseas').show();
    }
  });
  
  // Timer function
  var current_timer = new Date();
  var current_day1 = current_timer.getDay();
  var current_time1 = current_timer.getHours();
  
  var current_day = current_timer.getUTCDay();
  var current_time = current_timer.getUTCHours();
  
  if(current_day == 0){
    // Sun
    $('.js_shipping_text5').show();
  } else if (current_day == 1) {
    // monday
    if(current_time < 10){
      $('.js_shipping_text1').show();
    } else {
      $('.js_shipping_text2').show();
    }
    
  } else if (current_day == 2) {
    // tuesday
    if(current_time < 10){
      $('.js_shipping_text1').show();
    } else {
      $('.js_shipping_text2').show();
    }
    
  } else if (current_day == 3) {
    // wed
    if(current_time < 10){
      $('.js_shipping_text1').show();
    } else {
      $('.js_shipping_text2').show();
    }
    
  } else if (current_day == 4) {
    // thur
    if(current_time < 10){
      $('.js_shipping_text1').show();
    } else {
      $('.js_shipping_text2').show();
    }
    
  } else if (current_day == 5) {
    // Fri
    if(current_time < 10){
      $('.js_shipping_text3').show();
    } else {
      $('.js_shipping_text4').show();
    }
    
  } else if (current_day == 6) {
    // Sat    
    $('.js_shipping_text5').show();
  }

  // product page review modal
  $('.js-product-review').click(function(){
    product_review_modal();
    if(!$('.product-review-modal').hasClass("active")){
      $('.product-review-modal').toggleClass("active");
    } 
  });
  $('.close-pdp-review-modal').click(function(){
    $('.product-review-modal').toggleClass("active");
  });

});

function product_review_modal(){
  $.ajax({
    url:'https://jandjoy.com/pages/reviews',
    type:'GET',
    success: function(data){
      $('.js-product-review-modal').html($(data).find('#judgeme_all_reviews_page').html());
    }
  });
}
